import axios from "axios";
import { Menu, Send, X } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../Images/Logos/PNG.png";

const Navbar = ({ color }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSmallDropdownOpen, setIsSmallDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const checkToken = async () => {
      try {
        const response = await axios.post(
          "http://localhost:5000/api/verify",
          null,
          {
            headers: {
              auth: token,
            },
          }
        );
        console.log(response.data.message);
        response.data.message == "Verified"
          ? setIsAdmin(true)
          : setIsAdmin(false);
      } catch (error) {
        setIsAdmin(false);
      }
    };
    checkToken();
  }, [token]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsSmallDropdownOpen(false);
    }
  };

  const openDropDown = () => {
    setIsSmallDropdownOpen(true);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="pt-6 lg:pb-4 md:pb-4 pb-0 w-full  mx-auto px-2 lg:px-8 bg-white  rounded-b-lg">
      <div className=" flex justify-between items-center">
        {/* Logo and Name */}
        <div className="flex  items-start">
          <a
            className="flex items-center text-teal-800 no-underline hover:no-underline font-semibold text-xl lg:text-2xl p-0"
            href="#"
          >
            <img
              src={logo}
              className="lg:w-12 lg:h-12 md:w-10 md:h-10 w-8 h-8 block mr-2"
            />
            Solvexa
            <span className="text-teal-500 p-1">Marketing</span>
          </a>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:hidden lg:flex space-x-4 relative  font-medium">
          <a
            href="/"
            className="relative pb-1 text-teal-500 hover:text-teal-800 transition-colors duration-300 hover:after:w-full after:w-0 after:h-0.5 after:bg-teal-500 after:absolute after:left-0 after:bottom-0 after:transition-all after:duration-300"
          >
            Home
          </a>
          <a
            href="/about"
            className="relative pb-1 text-teal-500 hover:text-teal-800 transition-colors duration-300 hover:after:w-full after:w-0 after:h-0.5 after:bg-teal-500 after:absolute after:left-0 after:bottom-0 after:transition-all after:duration-300"
          >
            About Us
          </a>

          {/* Services Dropdown */}
          {/* Services Dropdown */}
          <div
            className="relative"
            ref={dropdownRef}
            onMouseEnter={() => setIsSmallDropdownOpen(true)}
            onMouseLeave={() => setIsSmallDropdownOpen(false)}
          >
            <a
              href="/services"
              className="font-medium relative pb-1 text-teal-500 hover:text-teal-800 transition-colors duration-300 hover:after:w-full after:w-0 after:h-0.5 after:bg-teal-500 after:absolute after:left-0 after:bottom-0 after:transition-all after:duration-300"
            >
              Services
            </a>
            {/* Dropdown Menu */}
            {isSmallDropdownOpen && (
              <div className="block z-10 absolute left-0 mt-2 w-52 bg-white shadow-lg rounded-lg">
                <a
                  href="/services/graphicDesign"
                  className="block px-4 py-2 text-teal-800 hover:bg-teal-600 hover:rounded-t-lg hover:text-white"
                >
                  Branding
                </a>
                <a
                  href="/services/videoEditing"
                  className="block px-4 py-2 text-teal-800 hover:bg-teal-600 hover:text-white"
                >
                  Video Editing
                </a>
                <a
                  href="/services/SocialMediaMarketing"
                  className="block px-4 py-2 text-teal-800 hover:bg-teal-600 hover:text-white"
                >
                  Social Media Marketing
                </a>
                <a
                  href="/services/SocialMediaManagement"
                  className="block px-4 py-2 text-teal-800 hover:bg-teal-600 hover:text-white"
                >
                  Social Media Management
                </a>
                <a
                  href="/services/SEO"
                  className="block px-4 py-2 text-teal-800 hover:bg-teal-600 hover:text-white"
                >
                  SEO
                </a>
                <a
                  href="/services/WebDevelopment"
                  className="block px-4 py-2 text-teal-800 hover:bg-teal-600 hover:rounded-b-lg hover:text-white"
                >
                  Web Development
                </a>
              </div>
            )}
          </div>

          <a
            href="/reviews"
            className="relative pb-1 text-teal-500 hover:text-teal-800 transition-colors duration-300 hover:after:w-full after:w-0 after:h-0.5 after:bg-teal-500 after:absolute after:left-0 after:bottom-0 after:transition-all after:duration-300"
          >
            Reviews
          </a>
          <a
            href="/blog"
            className="relative pb-1 text-teal-500 hover:text-teal-800 transition-colors duration-300 hover:after:w-full after:w-0 after:h-0.5 after:bg-teal-500 after:absolute after:left-0 after:bottom-0 after:transition-all after:duration-300"
          >
            Blogs
          </a>
          <a
            href="/faqs"
            className="relative pb-1 text-teal-500 hover:text-teal-800 transition-colors duration-300 hover:after:w-full after:w-0 after:h-0.5 after:bg-teal-500 after:absolute after:left-0 after:bottom-0 after:transition-all after:duration-300"
          >
            FAQ's
          </a>
          <a
            href="/privacy"
            className="relative pb-1 text-teal-500 hover:text-teal-800 transition-colors duration-300 hover:after:w-full after:w-0 after:h-0.5 after:bg-teal-500 after:absolute after:left-0 after:bottom-0 after:transition-all after:duration-300"
          >
            Terms and Policies
          </a>
          {/* {isAdmin && (
            <a
              href="/blog/add"
              className="relative pb-1 text-teal-500 hover:text-teal-800 transition-colors duration-300 hover:after:w-full after:w-0 after:h-0.5 after:bg-teal-500 after:absolute after:left-0 after:bottom-0 after:transition-all after:duration-300"
            >
              Add Blog
            </a>
          )} */}
          {isAdmin && (
            <a
              href="/blog/admin/view"
              className="relative pb-1 text-teal-500 hover:text-teal-800 transition-colors duration-300 hover:after:w-full after:w-0 after:h-0.5 after:bg-teal-500 after:absolute after:left-0 after:bottom-0 after:transition-all after:duration-300"
            >
              View and Edit Blogs
            </a>
          )}
          {isAdmin && (
            <a href="/contact">
              <button
                className="bg-teal-500 font-medium text-white px-4 py-2 rounded hover:bg-teal-800 items-center space-x-2 hidden md:flex"
                onClick={() => {
                  localStorage.removeItem("token");

                  setToken(null);
                  navigate("/");
                }}
              >
                <span>Logout</span>
              </button>
            </a>
          )}
        </div>
        {!isAdmin && (
          <a href="/contact">
            <button className="md:hidden bg-teal-500 font-medium text-white px-4 py-2 rounded hover:bg-teal-600 items-center space-x-2 hidden lg:flex">
              <span>Contact us</span>
              <Send className="w-5" />
            </button>
          </a>
        )}

        {/* Mobile Menu Button */}
        <div className="md:block lg:hidden">
          <button onClick={toggleMenu} className="text-teal-950">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown */}
      <div
        className={` mb-5 transform transition-max-height duration-500 ease-in-out overflow-hidden ${
          isOpen ? "p-4 max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        } block md:block lg:hidden bg-blue-400 mt-2 p-1 space-y-2`}
      >
        {isAdmin && (
          <a
            href="/blog/admin/view"
            className="block text-white hover:text-teal-900"
          >
            View and Edit Blogs
          </a>
        )}

        <a href="/" className="block text-white hover:text-teal-900">
          Home
        </a>
        <a href="/about" className="block text-white hover:text-teal-900">
          About Us
        </a>
        {/* Services Dropdown in Mobile */}
        <div className="group">
          <a href="/services" className="block text-white hover:text-teal-900">
            Services
          </a>
          <div className="mt-2 ml-4 space-y-2 block">
            <a
              href="/services/graphicDesign"
              className="block text-white hover:text-teal-900"
            >
              Branding
            </a>
            <a
              href="/services/videoEditing"
              className="block text-white hover:text-teal-900"
            >
              Video Editing
            </a>
            <a
              href="/services/SocialMediaMarketing"
              className="block text-white hover:text-teal-900"
            >
              Social Media Marketing
            </a>
            <a
              href="/services/SocialMediaManagement"
              className="block text-white hover:text-teal-900"
            >
              Social Media Management
            </a>
            <a
              href="/services/SEO"
              className="block text-white hover:text-teal-900"
            >
              SEO
            </a>
            <a
              href="/services/WebDevelopment"
              className="block text-white hover:text-teal-900"
            >
              Web Development
            </a>
          </div>
        </div>

        <a href="/blog" className="block text-white hover:text-teal-900">
          Blogs
        </a>
        <a href="/reviews" className="block text-white hover:text-teal-900">
          Reviews
        </a>
        <a href="/privacy" className="block text-white hover:text-teal-900">
          Terms and Policies
        </a>

        <a href="/faqs" className="block text-white hover:text-teal-900">
          FAQs
        </a>
        {!isAdmin && (
          <a href="/contact">
            <button className="mt-4 w-full bg-white border-blue-400 border text-blue-400 px-4 py-2 rounded hover:bg-blue-400 hover:text-white ">
              Contact
            </button>
          </a>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
